import { Box, Button, Card, CardActions, CardContent, CssBaseline, Grid, ThemeProvider, Typography, createTheme, Stack, Avatar, Link } from '@mui/material'
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom'; // ใช้สำหรับลิงก์ภายในแอป
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const defaultTheme = createTheme({
    typography: {
        fontFamily: '"Kanit", "Roboto", sans-serif',
        fontSize: 16,
    },
    palette: {
        primary: {
            main: '#2e7d32',
            dark: '#1b5e20',
        },
    },
});

function MainRouteFooter() {
    const { t } = useTranslation();


    const logos = [
        { src: "/logo-kku.png", link: "https://www.kku.ac.th/" },
        { src: "/logo-kkbs.png", link: "https://kkbs.kku.ac.th/" },
        { src: "/logo-captour.png", link: "https://kkbs.kku.ac.th/?lang=en" },
        { src: "/logo-kkuttravel.png", link: "https://kkbs.kku.ac.th/web/page-tour.php" },
        { src: "/logo.png", link: "https://letsgolowcarbons.com/" },
    ];
    const socialLinks = [
        { icon: "/instagram.png", link: "https://www.instagram.com/letsgolow_carbon?igsh=MTU5Y3lxM2xpdXAwcA%3D%3D&utm_source=qr" },
        { icon: "/facebook.png", link: "https://www.facebook.com/share/15kfWWbFtb/?mibextid=wwXIfr" },
        { icon: "/line.png", link: "https://line.me/R/ti/p/@154wgcef" },
        { icon: "/tik-tok.png", link: "https://www.tiktok.com/@letsgolowcarbon.kkbs?_t=ZS-90flX3moZ77&_r=1" },
        { icon: "/youtube.png", link: "https://youtube.com/@letsgolowcarbon-m2v?si=cciC1aQwA6LH__39" },
    ];
    return (
        <ThemeProvider
            theme={defaultTheme}>
            <CssBaseline />
            <Box
                sx={{
                    maxWidth: { xs: '95%', sm: 800 },
                    mx: 'auto',
                    px: 4,
                    pt: { xs: 3, sm: 'clamp(16px, calc(var(--app-vh, 1vh) * 3.5), 32px)' },
                    pb: { xs: 'calc(88px + env(safe-area-inset-bottom))', sm: 10 }, // เว้นที่ให้ปุ่มกลับขึ้นบน (FAB) + ขอบล่าง iPhone
                    borderRadius: 2,
                    color: 'black',
                }}
            >
                <Stack spacing={{ xs: 2, sm: 'clamp(8px, calc(var(--app-vh, 1vh) * 2), 24px)' }} alignItems="center" width="100%">
                    <Box
                        display="flex"
                        justifyContent="center"
                        gap={2}
                        mt={2}
                        flexWrap={{ xs: 'wrap', sm: 'nowrap' }}

                    >
                        {socialLinks?.map((logo, i) => (
                            <a
                                key={i}
                                href={logo?.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ display: 'inline-block', cursor: 'pointer' }}
                            >
                                <Avatar
                                    src={logo?.icon}
                                    variant="square"
                                    sx={{
                                        width: 'auto',
                                        // ขนาดเดิม 30/40px เป็นค่าสูงสุด — จอเตี้ย (เช่น iPad แนวนอน) ย่อลงตามความสูงจอ
                                        height: { xs: 'clamp(26px, calc(var(--app-vh, 1vh) * 4), 30px)', sm: 'clamp(28px, calc(var(--app-vh, 1vh) * 4.5), 40px)' },
                                        objectFit: 'contain',
                                        borderRadius: 1,
                                        p: 0.5,
                                        transition: 'transform 0.2s, box-shadow 0.2s',
                                        '&:hover': {
                                            transform: 'scale(1.05)',
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',  // เอฟเฟกต์เงานูนขึ้น
                                        },
                                    }}
                                />
                            </a>
                        ))}
                    </Box>

                    <Box
                        display="flex"
                        justifyContent="center"
                        gap={2}
                        mt={{ xs: 2, sm: 'clamp(8px, calc(var(--app-vh, 1vh) * 2.5), 32px)' }}
                        flexWrap={{ xs: 'wrap', sm: 'nowrap' }}
                    >
                        {logos.map((logo, i) => (
                            <a
                                key={i}
                                href={logo?.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ display: 'inline-block', cursor: 'pointer' }}
                            >
                                <Avatar
                                    src={logo?.src}
                                    variant="square"
                                    sx={{
                                        width: 'auto',
                                        height: { xs: 'clamp(38px, calc(var(--app-vh, 1vh) * 6), 50px)', sm: 'clamp(44px, calc(var(--app-vh, 1vh) * 7.5), 70px)' },
                                        objectFit: 'contain',
                                        borderRadius: 1,
                                        p: 0.5,
                                        bgcolor: 'transparent',
                                        transition: 'transform 0.2s, box-shadow 0.2s',
                                        '&:hover': {
                                            transform: 'scale(1.05)',
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',  // เอฟเฟกต์เงานูนขึ้น
                                        },
                                    }}
                                />
                            </a>
                        ))}
                    </Box>

                    <Box textAlign="center" mt={{ xs: 2, sm: 'clamp(8px, calc(var(--app-vh, 1vh) * 2), 24px)' }}>
                        <Typography variant="body2" sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}>
                            LET’S GO LOW CARBON BY CAPTOUR & KKU TRAVEL, KKBS, KKU © 2023
                        </Typography>
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            justifyContent="center"
                            mt={1}
                            alignItems="center"
                        >
                            <Link component={RouterLink} to="/privacy" underline="hover">
                                {t('menu.privacy_policy')}
                            </Link>
                            <Link component={RouterLink} to="/terms" underline="hover">
                                {t('menu.terms')}
                            </Link>
                            <Link component={RouterLink} to="/contact" underline="hover">
                                {t('menu.contacts')}
                            </Link>
                            <Link component={RouterLink} to="/about" underline="hover">
                                {t('menu.abouts')}
                            </Link>
                        </Stack>
                    </Box>
                </Stack>
            </Box>
        </ThemeProvider>
    )
}

export default MainRouteFooter